import { Component, EventEmitter, Output } from '@angular/core';
import { DataService } from '../data/data.service';


@Component({
    selector: 'app-cart-header',
    template: `
    <div class="w-100 p-1 ps-3 pe-1 d-flex justify-content-center align-items-center flex-row">

      <span
        *ngIf="!dataService.cashBoxClosed"
        class="d-inline-block bg-light rounded-pill py-1 px-3 ms-1 fs-5 min-w-160px text-center">
        {{dataService.cashBox.cashBalance | currency}}
      </span>

      <span
        *ngIf="dataService.cashBoxClosed"
        class="d-inline-block bg-light rounded-pill py-1 px-3 ms-1 fs-5 min-w-160px">&nbsp;</span>

    </div>
  `,
    styles: [`
    :host {
      display: block;
    }

    .w-25px {
      width: 25px;
    }
  `],
    standalone: false
})
export class CartHeaderComponent {
  @Output() newCustomerClicked: EventEmitter<void> = new EventEmitter<void>();

  constructor(public dataService: DataService) {
  }
}
